<!--<template>
  <el-popover placement="bottom" width="700" trigger="click" @show="popoverShow">
    <el-row align="middle" class="row" type="flex">
      <div class="breadcrumbDiv">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
          <el-breadcrumb-item
            class="breadcrumbCursor"
            v-if="taskGropuParent.length>0"
            @click.native="onBreadcrumb(null,null)"
          >根目录</el-breadcrumb-item>
          <el-breadcrumb-item
            class="breadcrumbCursor"
            @click.native="onBreadcrumb(item.ID,item)"
            v-for="item in taskGropuParent"
            :key="item.ID"
          >{{item.TASKNAME}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div style="width:100px;display: inline-block;">
        <el-link>切换视图</el-link>
      </div>
    </el-row>
    <taskFolder :isStore="false" :tableData="tableData" @dbclick="dbclick" @onclick="onclick"></taskFolder>
   
    <el-pagination
      @current-change="handleCurrentChange"
      v-show="totalCount>0"
      background
      layout="prev, pager, next"
      :current-page.sync="pageIndex"
      :page-size="pageSize"
      :total="totalCount"
    ></el-pagination>
    <el-tooltip slot="reference" content="收藏" placement="top" effect="light">
      <i class="iconfont icon-shoucangjia" style="cursor: pointer;"></i>
    </el-tooltip>
  </el-popover>
</template>
 <!--<el-scrollbar style="height:100%">
      <el-cascader-panel :options="tableData" :border="false" :props="cascaderProps"></el-cascader-panel>
    </el-scrollbar>-->
<template>
  <span>
    <el-tooltip slot="reference" content="收藏" placement="top" effect="light">
      <i class="iconfont icon-shoucangjia" @click="collect" style="cursor: pointer;"></i>
    </el-tooltip>
    <div
      class="side-nav"
      v-if="navMenuShow"
      :style="{top:top+'px'}"
      @mouseenter="isFade = false"
      :class="{ 'is-fade': isFade }"
    >
      <el-scrollbar class="page-component__scroll" :style="{height:isSetHeight? `calc(100vh - ${top}px)`:false}" ref="componentScrollBar">
        <ul>
          <li class="nav-item" ref="collect_Li" v-for="(item, key) in tableData" :key="key">
          <el-tooltip slot="reference" :content="item.NODENAME" placement="top" effect="light">
            <a
              @mouseenter="mouseenter(item,key, $event)"
              @click="openBlank(item)"
              @contextmenu.prevent="liContextmenu(item)"
              :style="{width:(item.NODETYPE == 3 || item.NODETYPE == 2)?'160px':'188px'}"
              style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;display: inline-block;"
              @mouseleave="mouseleave(item,$event)"
            >
              <svg class="icon alSvgIcon" aria-hidden="true">
                <use :xlink:href="'#'+getTaskTypeIcon(item)" />
              </svg>
              <!--<span style="width: calc(100% - 100px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 16px;
    text-align: left;
              display: block;">{{item.NODENAME}}</span>-->
                   {{item.NODENAME}}
            </a>
            </el-tooltip>
            <i
                v-if="item.NODETYPE == 3 || item.NODETYPE == 2"
                style="position: relative;top: -14px;color: #333;font-weight: bolder;"
                class="el-icon-arrow-right"
              ></i>
            <collect-node :node="item" @liContextmenu="liContextmenu"></collect-node>
          </li>
        </ul>
      </el-scrollbar>
      <contextMenu
      ref="contextMenu"
      :contextMenu="contextmenuRow"
      :isShowOpenButton="false"
      :multipleSelection="multipleSelection"
      @getNodeLoad="getNodeLoad"
    ></contextMenu>
    </div>
    <div
      v-if="navMenuShow"
      @click="collectHide"
      style="position: fixed;z-index:99;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: .5;"
    ></div>
  </span>
</template>

<script>
import { getAllCurrentUserTask } from "@/api/modules/basicData/task";
import { AddTaskViewHistory } from "@/api/modules/basicData/task";
import { GetSubTaskTreePathByTaskId } from "@/api/modules/basicData/basicTask";
import folderApi from "@/api/modules/basicData/folder";
import Linq from "linq";
import taskFolder from "./taskFolder";
import CollectNode from "./collect-node.vue";
import contextMenu from "@/views/task/common/contextmenuCollect.vue";
import { mapState } from "vuex";
let id = 0;
export default {
  components: {
    taskFolder,
    CollectNode,
    contextMenu,
  },
  data() {
    return {
      contextmenuRow: {},
      multipleSelection: [],

      isFade: false,
      navMenuShow: false,
      isSetHeight:false,//是否设置收藏高度
      currentNode: {},
      pageIndex: 1,
      pageSize: 20,
      totalCount: 0,
      tableData: [],
      tableList: [],
      taskGropuParent: [],
      cascaderProps: {
        emitPath: false,
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          if (level > 0) {
            collectX = collectX - level * 180;
            alert(level * 180);
            alert(collectX);
          }
          setTimeout(() => {
            const nodes = Array.from({ length: level + 1 }).map(item => ({
              ID: ++id,
              NODENAME: `选项${id}`,
              leaf: level >= 10
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 1000);
        },
        value: "NODEID",
        label: "NODENAME",
        leaf: "leaf"
      },
      collectX: 0,
      collectY: 0
    };
  },
  props:{
    top:{
      type:Number,
      default:70
    }
  },
  computed: {
    ...mapState({
      userId: state => state.task.userId,
      Person: state => state.folder.Person
    })
  },
  methods: {
    lazyLoad(node, resolve) {},
    liContextmenu(row) {
      console.log('liContextmenu',row);
      this.contextmenuRow = row;
      let Selection={...row}
      this.multipleSelection = [Selection];

      event.preventDefault();
      const postition = {
        top: event.clientY,
        left: event.clientX
      };
      this.$refs.contextMenu.Show(postition);
    },
    getTaskTypeIcon(row) {
      let filter = this.$options.filters["taskStateIcon"];
      return row.NODETYPE == 3? "icon-wenjianjia": row.NODETYPE == 2
        ? "icon-zul"
        : filter(row.RELATIONSTATE);
    },
    popoverShow() {
      this.handleCurrentChange(this.pageIndex);
    },
    collectHide() {
      this.navMenuShow = false;
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      let paras = {
        TaskInstance: "",
        EventInstance: "",
        ExcuteState: "fuwu_0,fuwu_1",
        TaskName: "",
        CreateTime2: "",
        CreateTime1: "",
        CreateUser: {},
        ExcuteUser: {},
        TaskType: "",
        state: ["fuwu_0", "fuwu_1"],
        CreateClass: "",
        CreateSource: "",
        TypeIndex: "5",
        ServerCenterIds: "",
        TaskRightId: "",
        TaskDegree: "",
        AcceptTime1: "",
        AcceptTime2: "",
        CompleteTime1: "",
        CompleteTime2: "",
        TransferTime1: "",
        TransferTime2: "",
        CloseTime1: "",
        CloseTime2: "",
        OutDateTime1: "",
        OutDateTime2: "",
        LinkManId: "",
        TaskMemeberId: "",
        DeviceId: "",
        FaultType: "",
        Location: "",
        LinkManIds: "",
        TaskMemeberIds: "",
        CreateUserIds: "",
        ExcuteUserIds: "",
        RoleType: "1,2",
        OutOfDate: "",
        TaskClassCode: "",
        CallerPhone: "",
        ANSWERPHONE: "",
        ANSWERTYPE: "",
        ANSWERUSERID: [],
        OrderTime: "ACTUALOPERATETIME",
        ConvertUserIds: "",
        TaskStyle: 0,
        CurrentUserId: this.userId,
        Alone: {
          ExcuteMe: false,
          ConvertMe: false,
          CreateMe: false,
          LinkManMe: false,
          TaskMemeberMe: false,
          ConvertUserIds: [],
          meCompanyDept: false,
          meServiceCenter: false,
          receiveTimeRange: [],
          receiveTimeRadio: "",
          receiveTimeInput: "",
          receiveTimeDynamic: 1,
          circulationtimeRange: [],
          circulationtimeRadio: "",
          circulationtimeInput: "",
          circulationTimeDynamic: 1,
          audittimeRange: [],
          audittimeRadio: "",
          audittimeInput: "",
          auditTimeDynamic: 1,
          completetimeRange: [],
          completetimeRadio: "",
          completetimeInput: "",
          completeTimeDynamic: 1,
          createtimeRange: [],
          createtimeRadio: "",
          createtimeInput: "",
          createTimeDynamic: 1,
          closetimeRange: [],
          closetimeRadio: "",
          closetimeInput: "",
          closeTimeDynamic: 1,
          overduetimeRange: [],
          overduetimeRadio: "",
          overduetimeInput: "",
          overduetimeDynamic: 1,
          companyDeptCheckList: [1, 2],
          ExcuteUserIds: [],
          CreateUserIds: [],
          MemeberUserIds: [],
          LinkUserIds: [],
          TaskRightIds: [],
          DeviceIds: [],
          selectedCreateUser: [],
          selectedExcuteUser: [],
          ServerCenterIds: [],
          FaultType: [],
          stateName: "我关注的",
          taskTypeName: "",
          TaskDegreeName: "",
          SourceName: "",
          FaultTypeName: "",
          DeviceName: "",
          TypeIndexName: "",
          CreateClassName: "",
          TaskRightName: "",
          ExcuteUserName: "",
          CreateUserName: "",
          MemeberUserName: "",
          LinkUserName: "",
          ServerCenterName: "",
          TaskRightTypes: [],
          OutOfDateName: "",
          IsStateCondition: false,
          IsTeamCondition: false,
          TaskClass: "",
          serviceDesk: "",
          ViewType: "",
          ViewTypeName: "",
          AnswerUserName: "",
          AnswerTypeName: "",
          ConvertUserName: ""
        },
        queryTitle: [
          {
            title: "角色分类",
            key: "TypeIndex",
            value: "我关注的"
          }
        ]
      };
      getAllCurrentUserTask({
        PageIndex: val,
        PageSize: this.pageSize,
        TypeIndex: -1,
        TaskParas: paras
      }).then(data => {
        if (data) {
          if (data.Items.length > 0) {
            this.tableList = this.tableData = data.Items;
            this.totalCount = data.TotalItems;
          } else {
            if (val > 1) this.handleCurrentChange(1);
          }
        }
      });
    },
    async collect(ev) {
      // this.handleCurrentChange(this.pageIndex);
      let paras = {
        IdPath: "",
        NodeName: "",
        CreateTime1: "",
        CreateTime2: "",
        TaskType: "",
        IsRoot: true,
        PermissionType: 0
      };
      paras.Person = this.Person;
      this.tableData = await folderApi.GetTaskTreePathList(paras).then(res => {
        if (res && res.length > 0) {
          res = Linq.from(res)
            .orderByDescending(item => item.CREATETIME)
            .toArray();
          res.forEach(item => {
            item.Level = 1;
            item.isLeaf = item.CHILDRENCOUNT == 0;
            item.PermissionType = paras.PermissionType;
            item.isChildren = false;
          });
          return res;
        } else {
          return [];
        }
      });

      if((this.tableData.length*40+this.top)>document.body.offsetHeight){
        this.isSetHeight = true;
      }else{
        this.isSetHeight = false;
      }
      
      console.log("tableData", this.tableData);
      this.navMenuShow = this.navMenuShow ? false : true;
      // this.popoverShow();
      // this.collectX=ev.pageX-90
      // alert(ev.pageY)
      // alert(ev.pageX)
    },
    
    mouseenter(data,index, $event) {
      console.log('srcElement',$event.srcElement)
      console.log($event.srcElement.offsetTop)
      // console.log('$event',$event)
      // console.log('$el',this.$refs.collect_Li[index]);
      // console.log("mouseenter", data.NODENAME);
      // console.log('$event',$event)
      // data.pageY=$event.pageY
      // data.pageX = data.Level*200

      this.currentNode.isChildren = false;
      if (!data.isLoad && (data.NODETYPE == 3 || data.NODETYPE == 2)) {
        let paras = {
          NodeId: data.NODEID,
          IsRoot: false,
          PermissionType: 0
        };
        paras.Person = this.Person;
        folderApi.GetTaskTreePathList(paras).then(res => {
          if (res && res.length > 0) {
            res = Linq.from(res)
              .orderByDescending(item => item.CREATETIME)
              .toArray();
            res.forEach(item => {
              item.isLeaf = item.CHILDRENCOUNT == 0;
              item.PermissionType = paras.PermissionType;
              item.Level = 2;
              item.isChildren = false;
            });
            data.children = res;
            data.style = this.getPagePosition($event.srcElement.offsetTop, $event.pageY, data);
            data.isLoad = true;
            data.isChildren=true
            this.currentNode = data;
          }
        });
      } else if (data.NODETYPE == 3 || data.NODETYPE == 2) {
        data.isChildren = true;
        this.currentNode = data;
        data.isChildren=true
        data.style = this.getPagePosition($event.srcElement.offsetTop, $event.pageY, data);
      } else {
        if(data.NODETYPE != 0){
          data.isChildren=true
          data.style = this.getPagePosition($event.srcElement.offsetTop, $event.pageY, data);
        }
      }
    },
    getPagePosition(pageX, pageY, data) {
      let postion = {};
      let pageHeight = document.body.offsetHeight;
      let pageWidth = document.body.offsetWidth;
      // alert(pageHeight);
      // alert(pageY+data.children.length*40);
      pageX=pageX+70;
      if (pageHeight < pageX+ + data.children.length * 40) {
        postion.bottom = "0px";
      } else {
        postion.top = pageX + "px";
      }

      if (pageWidth < (data.Level + 1) * 200) {
        postion.left = "0px";
      } else {
        postion.right = data.Level * 200 + "px";
      }
      return postion;
    },
    openBlank(row) {
      if(row.NODETYPE !==0){
        return false;
      }
      let pars = {
        TaskId: row.RELATIONID,
        Person: this.Person
      };
      AddTaskViewHistory(pars).then(pmevent => {});
      let hostUrl = location.href.split("#")[0];
      if (typeof jsObj == "undefined") {
        let routeUrl = this.$router.resolve({
          path: "/task-detailspage",
          query: {
            taskid: row.RELATIONID
          }
        });
        window.open(routeUrl.href);
      } else {
        let routeUrl = this.$router.resolve({
          path: "/task-detailspage",
          query: {
            taskid: row.RELATIONID,
            code: this.code
          }
        });
        jsObj.Invoke("OpenWebBrowser", hostUrl + routeUrl.href);
      }
    },
    mouseleave(data, $event) {
      // data.isChildren=false;
      console.log("mouseleave", data.NODENAME);
    },
    onBreadcrumb(id, row) {
      if (id) {
        this.GetSubTaskTreePathByTaskId(id, row);
        // this.taskGropuParent = getParents(this.tableData, id);
        // this.tableData = this.tableData.filter(
        //   p => p.PARENTID === id
        // )
      } else {
        this.taskGropuParent = [];
        this.tableData = this.tableList;
      }
    },
    dbclick(row) {
      if (row.TASKTYPE == "E9354DE41375") {
        // this.$store.commit("changeCurTask", {});
        this.GetSubTaskTreePathByTaskId(row.ID, row);
      } else {
        // this.changeCurTask(row);
        this.openBlank(row.ID);
      }
    },
    onclick(row) {},
    GetSubTaskTreePathByTaskId(taskId, row) {
      GetSubTaskTreePathByTaskId(taskId, this.userId).then(result => {
        if (result.length > 0) {
          this.setTaskGroupCurrentData({
            taskGroupCurrent: result,
            row: row
          });
        } else {
          this.setTaskGroupCurrentData({
            taskGroupCurrent: [],
            row: row
          });
        }
      });
    },
    setTaskGroupCurrentData(info) {
      let index = Linq.from(this.taskGropuParent).indexOf(
        x => x.ID == info.row.ID
      );
      console.log("index", index);
      if (index >= 0) {
        this.taskGropuParent = Linq.from(this.taskGropuParent)
          .take(index + 1)
          .toArray();
        console.log("面包屑:", this.taskGropuParent);
      } else {
        // let taskGropuParent= state.taskGropuParent;
        this.taskGropuParent.push(info.row);
        // this.taskGropuParent=taskGropuParent
      }
      this.tableData = info.taskGroupCurrent;
    },
    // openBlank(taskid) {
    //   let pars = {
    //     TaskId: taskid,
    //     Person: this.Person
    //   };
    //   AddTaskViewHistory(pars).then(pmevent => {});
    //   let routeUrl = this.$router.resolve({
    //     path: "/task-detailspage",
    //     query: { taskid: taskid }
    //   });
    //   window.open(routeUrl.href, "_blank");
    // },
    getNodeLoad(){
      this.navMenuShow=false
    },
    async GetTaskTreePathList(paras) {
      paras.Person = this.Person;
      return await folderApi.GetTaskTreePathList(paras).then(res => {
        if (res && res.length > 0) {
          res = Linq.from(res)
            .orderByDescending(item => item.CREATETIME)
            .toArray();
          res.forEach(item => {
            item.isLeaf = item.CHILDRENCOUNT == 0;
            item.PermissionType = paras.PermissionType;
            this.treeList.push(item);
          });
          return res;
        } else {
          return [];
        }
      });
    }
  },
  watch: {
    // pageIndex(newIndex,oldIndex){
    //   if()
    // }
  }
};
</script>

<style lang="scss" scoped>
.breadcrumbDiv {
  width: calc(100% - 90px);
  display: inline-block;
}
.row {
  /deep/ .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
    white-space: nowrap;
  }
  /deep/ .el-scrollbar__wrap {
    overflow: scroll;
  }
}
</style>
<style lang="scss" scoped>
.side-nav {
  box-sizing: border-box;
  right: 10px;
  width: 200px;
  top: 70px;
  transition: opacity 0.3s;
  border: 1px solid #eee;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 4px, rgba(0, 0, 0, 0.04) 0px 0px 6px;
  position: fixed;
  text-align: left;
  z-index: 100;
  // background: white;
  background: rgb(236, 245, 255);
  right: 0px;
  &.is-fade {
    transition: opacity 3s;
  }

  li {
    list-style: none;
    padding-left: 10px;
  }

  li:hover,&:active{
    
  }

  .nav-item {
    a {
      font-size: 16px;
      color: #333;
      line-height: 40px;
      height: 40px;
      margin: 0;
      padding: 0;
      text-decoration: none;
      display: block;
      cursor: pointer;
      position: relative;
      transition: 0.15s ease-out;
      font-weight: bold;
      // &:hover,
      // &.active {
      //   color: #409eff;
      // }
      .alSvgIcon {
        width: 20px;
        height: 20px;
        vertical-align: middle;
        fill: currentColor;
        overflow: hidden;
      }
    }
    &:hover,
    &.active {
          color: #409eff;
          background: #909399;
        }

    .nav-item {
      a {
        display: block;
        height: 40px;
        color: #444;
        line-height: 40px;
        font-size: 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: 540;
        // &:hover,
        // &.active {
        //   color: #409eff;
        // }
      }
    }

    &.sponsors {
      & > .sub-nav {
        // margin-top: -10px;
      }

      & > a {
        color: #777;
        font-weight: 300;
        font-size: 14px;
      }

      .nav-item {
        display: inline-block;

        a {
          height: auto;
          display: inline-block;
          vertical-align: middle;
          margin: 8px 12px 12px 0;

          img {
            width: 42px;
          }
        }

        &:first-child a img {
          width: 36px;
        }
      }
    }
  }

  .nav-group__title {
    font-size: 12px;
    color: #999;
    line-height: 26px;
    margin-top: 15px;
  }

  #code-sponsor-widget {
    margin: 0 0 0 -20px;
  }
}
.nav-dropdown-list {
  width: 120px;
  margin-top: -8px;
  li {
    font-size: 14px;
  }
}

.page-component__scroll {
  /deep/ .el-scrollbar__wrap {
    overflow-x: scroll;
  }
}
</style>